export interface LanguageData {
	Name: string;
	IsoCode: string;
	ShortCode: string;
}

export type ColorSchemeData = Array<{
	siteTheme: string;
	[key: string]: string;
}>;

export interface CashOutSportList {
	[key: string]: string[];
}

export interface VirtualStreamingLeagueGroupMap {
	[key: string]: string[];
}

export interface IntlResourceData {
	General: Record<string, string>;
	BetType: Record<string, string>;
	Choice: Record<string, string>;
}

export enum SwitchFromEnum {
	Default = -1,
	Mobile = 0,
	Desktop = 1
}

export interface DeepLinkSiteInfo {
	homeUrl: string;
	depositUrl: string;
	extendSessionUrl: string;
	loginUrl: string;
	signUpUrl: string;
	game: string;
	gameId: string;
	oddsType: number;
	skinColor: string;
	skinMode: number;
	forceDarkMode: boolean | null;
	tsId: string;
	switchFrom: SwitchFromEnum;
	isApp: boolean;
	themePreview: string;
	templateId: string;
	dptoken: string;
	switchFromUrl: string;
	clearCount: number;
	targetMenuTab: number;
	goToType: string;
	// 新增投注偏好相關欄位
	bettingMode: number;
	betslipStyle: number;
}

export interface ApiDomain {
	ctcdDomain: string;
}

export interface SiteConfigsSettingsData {
	BetbyComponentUrl: string;
	BookedBetLeagueGroup: Array<number>;
	RnRUrl: string;
	SupportLanguages: LanguageData[];
	SabaLeagueGroups: number[];
	LoginCheckInTime: number;
	WebSkinTypeAllow: string;
	EnableSingleWallet: boolean;
	OddsTypeList?: string;
	OddsTypeDefault?: string;
	ExpandedMatchCount: string;
	EnableCurrencyDisplay: boolean;
	EnableFilterSaba: boolean;
	NoSupportBetType: number[];
	CanSeeDecimalWidgets: boolean;
	DecimalWidgetsUrl: string;
	EnableStaticInfo: boolean;
	WeverdatStreamingUrl: string;
	KabaddiVStreamingUrl: string;
	EnableCurrencySymbolDisplay: boolean;
	EnableAcceptBetterOdds: boolean;
	EnableAISportSort: boolean;
	CanSeeGLiverStreaming: boolean;
	CheckStreamingList: boolean;
	StreamingSrc: number[];
	ImageServerUrl: string;
	EnableImageServer: boolean;
	SiteDefaultLanguage: LanguageData;
	EnableGalaxyCustomerSurvey: boolean;
	EnableGalaxyLeaveSurvey: boolean;
	EnableHistorySearch: boolean;
	EnableFps: boolean;
	EnableKafka: string;
	EnableApiBackend: boolean;
	EnableOddsServerApiBackend: boolean;
	EnableMyFavorite: boolean;
	EnableCDNMonitor: boolean;
	EnableNS1Monitor: boolean;
	FpsJsUrl: string;
	GalaxyGAId: string;
	GetMessageID: string;
	VirtualStreamingLeagueGroupMap: VirtualStreamingLeagueGroupMap;
	FilterStreamingSportList: string;
	FilterStreamingLeagueList: string;
	ExclusiveStreamerType: string;
	EnableDefaultOpenChatroom: boolean;
	EnableChatroom: boolean;
	DiscoverChatroomApiUrl: string;
	DiscoverPluginUrl: string;
	SiteName: string;
	GalaxyLogoType: number;
	EnableOpenStatisticInfo: boolean;
	CanSeeAdvantPlayVendorLobby: boolean;
	isShowSoccer5: boolean;
	isShowParlay5: boolean;
	CanSeeSportsLottery: boolean;
	//WebSkinTypeDefault:number;
	EnablePromotion: number;
	EnablePopularBetting: boolean;
	EnableTournamentGroup: boolean;
	EnableTournamentCountry: boolean;
	EnableTournamentKnockout: boolean;
	ApiBackendUrl: string;
	EnableStreamerSchedule: boolean;
	CanSeeLiveStreamer: boolean;
	/**
	 * using for exchange
	 */
	ExchangeAPIUrlForClient: string;
	/**
	 * using for casino royale
	 */
	SealComponentApiUrl: string;
	SingleWalletAdapterApi: string;
	EnableLicLobby: boolean;
	SabaSportsUrl: Record<string, string>;
	PopularBettingCount: number;
	Enable1x2Customization: boolean;
	EnableBookedDesc: boolean;
	/** 
	 * Used in user in-depth interviews
	*/
	EnableCustomerDeppConversation: boolean;
	EnableEsportsDeeplink: boolean;
	EnableTournament: boolean;
	CanSeeCasinoRoyale: boolean;
	EnableSingleMatchJackpot: boolean;
	EnableInHouseUrlApiBackend: boolean;
	EnableDesktopOrMobileToOnPremise: boolean;
	EnableSabaScore: boolean;
	EnableMarsRevisionNotice: boolean;
	HotMatchCount: number;
	EnableStreamingPlugin: boolean;
	ShowPromotionChatRoom: number[];
	EnableSabaCoinBet: boolean;
	EnableSabaCoinFlow: boolean;
	EnableNewSabaCoinFlow: boolean;
	EnableCoinRewardLevel: boolean;
	EnableSabaCoinStatement: boolean;
	EnableStatementSettleCache: boolean;
	EnableExchangeDeeplink: boolean;
	EnableSabaEuro: boolean;
	ReservationMaxCount: number;
	SabaEuroCupTournamentId: number;
	EnableOldStatementAlert: boolean;
	EnableNextAnalyse: boolean;
	BehaviorCatcherEntry: string;
	CanSeeVSTournament: boolean;
	EnablePinGoalMenuSports: number[];
	EnableFrontendRecordLog?: boolean;
	HideEndingGameCust5: boolean;
	FirstPageOrders: Array<number>;
	EnableDefaultOpenStreamer: boolean;
	EnableSlmtGv: boolean;
	EnableSpecialEvent: boolean;
	EnableStreaming: boolean;
	EnableFilterEvent: string;
	EnableVirtualBasketballBanner: boolean;
	EnableResultNormalApiBackend: boolean;
	EnableMenuApiBackend: boolean;
	EnableSportSortApiBackend: boolean;
	EnableResultOutrightApiBackend: boolean;
	EnableResultDetailApiBackend: boolean;
	EnableResultPopupApiBackend: boolean;
	EnableParlayResultPopupApiBackend: boolean;
	EnableBannerInfoApiBackend: boolean;
	DisableApiBackendResultPopupSports: string;
	EnableOddsPageFeatureUpdatePopup: boolean;
	EnableDisplayServe: boolean;
	EnableEplLobbyBanner: boolean;
	VirtualSportsStreamingUrl: string;
	IsShowNGLuckyDraw: boolean;
	EnableSwitchDarkMode: boolean;
	EnablePHView: boolean;
	EnableGoldenDuel: boolean;
	EnableGoldenDuelPopup: boolean;
	EnableGoldenDuelLobbyBanner: boolean;
	PromotionGoldenDuelHourPeriod: string;
	EnableCwcJackpot: boolean;
	EnableCwcJackpotPopup: boolean;
	EnableCwcJackpotLobbyBanner: boolean;
	DirectApiUrl: string;
	EnableRevisionTutorialPopup: boolean;
	EnableVirtuallySoccerBanner: boolean;
	Enable1x2CustomizationHint: boolean;
	EnableHeadlessForGalaxy: boolean;
	EnableBetbyPopup: boolean;
	EnableBetbyEsoccerPopup: boolean;
	BetbyEsoccer1minLeagues: number[];
	TournamentWidgetData: {
		TournamentId: string;
		BraketOpenDate: string;
		Order: number;
	}[];
	IsShowTournamentPromotion: boolean;
	EnableSportEvent: boolean;
	EnableSportEventPopup: boolean;
	EnableSportEventWinnerList: boolean;
	// 範例資料
	// [
	// 	{
	// 	  "Key": "SportEventOddsData",
	// 	  "Value": "16,106192745,106962530,106962708,106962710,106962707,106962709,107044001,107044002,107044004,107043999,107044003,107044005,107044000,107044006,107103288,107103286,107103285,107103287"
	// 	},
	//   {
	// 	  "Key": "SportEventBannerData",
	// 	  "Value": "20:16,0:1|20:106192745,0:107868642|20:HHH,0:FHH|20:AAA,0:FAA|20:lbl_KRRecMatch01,0:lbl_KRRecMatch01"
	// 	}
	//   ]
	SportEventOddsData: string; // sportId,mainMatchId,matchIdList1,matchIdList2,matchIdList3 and so on
	SportEventBannerData: string; // sportId,matchId,teamNameH,teamNameA,description
	EnableSentry: boolean;
	SentryDSN: string;
	EnableDatadog: boolean;
	DatadogApplicationId: string;
	DatadogClientToken: string;
	CanSeeVS2Tournament: boolean;
	EnableDotLottieLoadingPage: boolean;
	EnableLicBasketballPlayerTab: boolean;
	EnableVersionUpgradePopup: boolean;
	EnableRewardAnnounceModal: boolean;
	EnableBetBuilderPlusPopup: boolean;
	BetbyBlitzLeagueList: string;
	IsShowBalance: boolean;
	EnableVoucherList: Array<number>; // VoucherType
	CorrectScoreSpreadAdjust: Array<number>; // CorrectScoreSpreadAdjust
}

export interface LicSettingsData {
	urls?: {
		apiBackend?: string;
		oddsServer?: string;
		pushNode?: string;
	};
	sportsbook?: {
		enabledBetBuilderPlusSportIDs?: number[];
		enableWcPromotionFeatureLists?: number[];
		enableBBPlusMinorBetTypesSportIds?: number[];
		enableQuickBetWidgetInSchedule?: boolean;
		enableVipProgramHint?: boolean;
		enableDeadballEarlyStreaming?: boolean;
		enableKeroPlayerProps: boolean;
		enableKeroPlayerPropsBetTypes: Array<string>;
		enableCSSection?: boolean;
		enableCSSectionBanner?: boolean;
		oddsPageFilterBetTypes?: string;
		termAndConditionsUrl?: string;
		enableStreamerBanner?: boolean;
		enablePromoStreamerFloatIcon?: boolean;
		enableWorldCupFeverPopup?: boolean;
		enableFootballLeagueResumesPopup?: boolean;
		enableFootballLeagueFixtureFrenzyPopup?: boolean;
		enableAIChat?: boolean;
		enableGreyOutAPI?: boolean;
		enableListPopupBanner?: boolean;
		enablePromotionSurvey?: boolean;
		enableStatScore?: boolean;
		enableOpenObserve?: boolean;
		openObserveClientToken?: string;
		openObserveSite?: string;
		openObserveSampleRateList?: number[];
	};
	nonSport?: {
		enableESoccerBattle?: boolean;
		enableESoccerBattlePromotion?: boolean;
		enablePasswordMigration?: boolean;
		virtualSoccerList?: number[];
		virtualSoccerLeagueList?: number[];
		virtualBasketballList?: number[];
		virtualRacingList?: number[];
		canSeePredictionMarket?: boolean;
		predictionMarketThemeColor?: string;
		enablePredictionMarketBanner?: boolean;
		enablePredictionMarketPopup?: boolean;
		predictionMarketNewTagUntil?: string;
	};
	/** Static asset host per migration group */
	staticAssetDomains?: Record<string, string>;
}

export interface OneAuthenticationInfo {
	OneAccessToken?: string;
	OneRefreshToken?: string;
}

export interface OddsServerSettingData {
	OddsServerUrl: string;
	OddsServerToken: string;
	OneAuthenticationInfo?: {
		AccessToken?: string;
		RefreshToken?: string;
	};
	ApiBackendUrlInfo?: {
		Url?: string;
		IsShouldClearDomain?: boolean;
	};
}

export interface ExtendOddsTokenData {
	/** Access Token */
	at: string;
	/** Refresh Token */
	rt: string;
	/** Old Token */
	ot: string;
};

export interface IpBlockData {
	SiteId: string;
	RefNo: string;
	Forward: string;
	CountryShort: string;
}

export interface SiteConfigsSettingsWithSessionData {
	WebSkinTypeAllow: string;
	WebSkinTypeDefault: number;
	SwitchFrom: number;
	SkinMode: number;
	EnableExchangeForBefore: boolean;
	EnablePhPortal: boolean;
	MainDomainOnPremise: string;
	VirtualSportSetting: {
		CanSeeBRVSBasketball: boolean;
	}
}

export type AppEnvironment = 'SIT' | 'UAT' | 'PROD';

export enum LicenseeTypeEnums {
	Api = 0,
	Athena = 1
}

export enum AthenaSiteNameEnums {
	'12B' = 4240700,
	'9Bet' = 4206300,
	Aoncash = 4202100,
	Athena000 = 4202600,
	Bolanation = 4215600,
	ITCBet = 4202400,
	M8bola = 4209400,
	Macaubet = 4201800,
	Q8bola = 4210200,
	SabaDemo = 4245600,
	Spondemo = 4200800,
}

export enum ApiSiteNameEnums {
	/** ivorysports */
	N8I = 4304900,
	TGXI = 4263800,
	TGXISW = 4325300,
	SampleSite = 4227600,
	Asiabet88 = 4200200,
	JBO = 4276800,
	N88 = 4240300,
	N8G = 4243700,
	N8B = 4243800,
}
